<template>
  <Container type="card-full">
    <div slot="header">
      <div v-if="+com.cositemcomstatus === 3 || !com.cositemcomstatus">
        <el-button type="primary" v-if="type === 1 || type === 2 || type === 4" @click="debounce('save')()"
          :loading="btnLoading">保存
        </el-button>
      </div>
      <el-button v-if="+com.cositemcomstatus === 1" type="primary" @click="debounce('submit')()">提交审核</el-button>
      <div v-if="+com.cositemcomstatus === 1" style="font-size:13px;color:red;">
        审批意见：{{ com.cositemappcomm }}
      </div>
      <span style="color:red;" v-if="+com.cositemcomstatus === 2">待审核</span>
      <vxe-button type="primary" v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection'
        status="">
        {{ btn.btnname }}
      </vxe-button>
    </div>
    <div class="main">
      <el-form :model="com" ref="ruleForm" label-position="right" class="mainfrom">
        <div class="row content">
          <el-form-item label="单位全称" alias="单位全称" prop="comfullname" :verify="validateComfullname">
            <el-input v-model="com.comfullname" :maxlength="80" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <div class="row from_input">
          <el-form-item label="单位类型" :required="true" prop="comtype">
            <el-select v-model="com.comtype" :disabled="(type === 4 || type === 3) ? true : false">
              <el-option v-for="(item, index) in comtypeList" :label="item.label" :value="item.value"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统一信用代码" prop="comidcode" :verify="validateComfullname">
            <el-input v-model="com.comidcode" :maxlength="50" :disabled="disable"></el-input>
          </el-form-item>
        </div>

        <div class="row from_input">

          <el-form-item label="手机号码" :verify="verifyPhone" prop="commobile">
            <el-input v-model="com.commobile" :maxlength="11" :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="联系人" verify prop="comcontact">
            <el-input v-model="com.comcontact" :maxlength="10" :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <div class="row from_input">

          <el-form-item label="单位电话" verify prop="comtel">
            <el-input v-model="com.comtel" :maxlength="20" :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="Email" :rules="[
            {
              type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']
            }]" prop="comemail">
            <el-input v-model="com.comemail" :maxlength="40" :disabled="disable"></el-input>
          </el-form-item>

        </div>
        <div class="row from_input">
          <el-form-item label="开户银行" verify prop="combank">
            <el-input v-model="com.combank" :maxlength="255" :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="开户账号" verify prop="combanknumber">
            <el-input v-model="com.combanknumber" :maxlength="50" :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <div class="row from_input" verify prop="comtaxtype">
          <el-form-item label="纳税类型">
            <div class="radio_w">
              <el-radio-group v-model="com.comtaxtype">
                <el-radio :label="1">一般纳税人</el-radio>
                <el-radio :label="2">小规模纳税人</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
        <div class="row from_input" v-if="type === 1 || type === 2 || type === 4">
          <!---->

        </div>
        <div class="row from_input">
          <el-form-item label="单位网站">
            <el-input v-model="com.comwebaddr" :maxlength="255" :disabled="disable">
              <!--<template slot="prepend">http://</template>-->
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="业务员"
                        v-if="$store.getters.loginUser.comtype ===1 || $store.getters.loginUser.comtype ===2">
            <el-select v-model="com.cositemsalesmanid" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in comsuserList" :label="item.username" :value="item.userid"
                         :key="index"></el-option>
            </el-select>
          </el-form-item> -->

        </div>
        <!-- <div class="row from_input" v-if="com.cositemcomtype !== 2">
           <el-form-item label="单位编号" :verify="validateComnumber" prop="comnumber">
            <el-input v-model="com.comnumber" :maxlength="4" :disabled="disable"></el-input>
          </el-form-item>
        </div> -->
        <div class="content">
          <el-form-item label="联系地址" prop="comaddr" verify>
            <el-input v-model="com.comaddr" :maxlength="255" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item label="业务范围" prop="comremark">
            <el-input type="textarea" :autosize="{ minRows: 5 }" :disabled="disable" v-model.trim="com.comremark"
              :maxlength="2048" show-word-limit></el-input>
          </el-form-item>
        </div>

        <div v-if="+com.comtype === 2">
          <div class="split-line"></div>
          <div>
            <el-form-item label="与代理协同方式" prop="cosapsynergyway">
              <div>
                <el-radio v-model="com.cositemapsynergyway" label="1">线上协同</el-radio>
                <el-radio v-model="com.cositemapsynergyway" label="2">线下协同</el-radio>
              </div>
            </el-form-item>
          </div>
        </div>
        <div v-if="+com.comtype === 2 && (+$store.getters.loginUser.comtype === 5 || +$store.getters.loginUser.comtype === 4) ">
          <div class="split-line"></div>
          <div>
            <el-form-item label-width="220px" label="是否在报价结束前显示报名列表" prop="isshowreglist">
              <div>
                <el-radio v-model="com.isshowreglist" label="1">显示</el-radio>
                <el-radio v-model="com.isshowreglist" label="2">不显示</el-radio>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 弹窗 -->
    <el-dialog title="附件信息" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <div class="addexport">
        <el-form :model="appendItem" ref="ruleAppend" label-position="right" class="mainfrom from_input">
          <el-form-item label="附件类型" prop="appendtype" verify>
            <el-select v-model="appendItem.appendtype" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in appendTypeList" :label="item.label" :value="item.value"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传附件" prop="appendurl" verify>
            <upload-pic-one @changed="setPic" :picUrl="appendItem.appendurl" folderName="com"
              text="选择文件"></upload-pic-one>
          </el-form-item>
          <div class="row">
            <el-form-item label="附件编号">
              <el-input v-model="appendItem.appendfilecode" :maxlength="128" show-word-limit
                :disabled="disable"></el-input>
            </el-form-item>

            <el-form-item label="附件名称" prop="appendfilename" verify>
              <el-input v-model="appendItem.appendfilename" :maxlength="128" show-word-limit
                :disabled="disable"></el-input>
            </el-form-item>
          </div>

        </el-form>
        <div style="overflow:hidden">
          <el-button type="primary" @click="saveAppend" style="float:right;margin-right:20px;">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="split-line"></div>
    <vggrid ref="xGrid" :list="list" tableheight="300" flexname="" :cols="cols" :showfooter="false" :showPage="false"
      :resizable="true" :needBlackRow="false" :needPopMenu="false" :canbeEdit="false" @cellClick="cellClick"
      :isOperate="btn.isOperate" :operateBtn="operateBtn" @vggridClick="vggridClick">
      <template slot="btn">
        <div class="btn-box">
          <vxe-button type="text" icon="el-icon-plus" v-if="type === 1 || type === 2 || type === 4" @click="addAppend">
            新增
          </vxe-button>
          <vxe-button type="text" icon="el-icon-edit-outline" v-if="type === 1 || type === 2 || type === 4"
            @click="chgAppend">
            修改
          </vxe-button>
          <vxe-button type="text" icon="el-icon-delete" v-if="type === 1 || type === 2 || type === 4" @click="delAppend">
            删除
          </vxe-button>
        </div>
      </template>
    </vggrid>
  </Container>
</template>

<script>
import request from '@/utils/request'
import vggrid from '../common/vggrid'
import utils from '../../assets/js/utils'
import common from '@/mixin/common'
import axios from 'axios'
import uploadPicOne from '../common/uploadPicOne'

const SUCCESS = 1
export default {
  name: "comform",
  mixins: [common],
  data() {
    return {
      com: {
        isshowreglist: '1'
      },
      type: Number(this.$route.params.type),
      disable: this.$route.params.type === 3 ? true : false,
      comtypeList: [],
      comtypes: [],
      list: [],
      btn: {},
      cols: [
        { type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80 },
        { field: 'appendtypedesc', fieldtype: 'C', title: '附件类型', calculExpr: '' },
        { field: 'appendfilecode', fieldtype: 'C', title: '文件编号', calculExpr: '' },
        { field: 'appendfilename', fieldtype: 'C', title: '文件名', calculExpr: '' }
        // { field: 'appendurl', fieldtype: 'C',title: 'URL',calculExpr:''}
      ],
      operateBtn: [
        { btncode: 'CHG', btnicon: 'el-icon-edit-outline', btnname: '修改' },
        { btncode: 'DEL', btnicon: 'el-icon-delete', btnname: '删除' }
      ],
      append: {},
      btnLoading: false,
      appendTypeList: [],
      appendItem: {},
      comsuserList: [],
      dialogVisible: false,
      iscomtypes: false //判断是否为代理和采购
    }
  },
  async activated() {
    await this.init()
    await this.getcomsuserList()
    await this.getAppendType()
    await this.getAppendList()
  },
  created() {
    this.$on('CHG', () => this.chgAppend())
    this.$on('DEL', () => this.delAppend())
  },
  watch: {},
  filters: {},
  components: { vggrid, uploadPicOne },
  deactivated() {
    this.com = {}
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr
    }
  },
  methods: {
    async init() {
      this.type = Number(this.$route.params.type)
      this.disable = this.$route.params.type === 3 ? true : false
      this.appendTypeList = []
      this.append = {}
      this.btn = {}
      this.isOperate,
        this.comtypeList = []
      this.appendItem = {}
      this.list = []
      this.comsuserList = []
      this.iscomtypes = false
      await this.getComtype()
      if (this.type !== 1) {
        if (this.$route.params.form) {
          this.com.comid = this.$route.params.form.comid
        } else {
          this.com.comid = this.$store.getters.loginUser.usercomid
          this.type = 4
        }
        await this.getCom()
      } else {
        this.com = this.$route.params.form
      }
    },
    verifyPhone(rul, val,callback) {
      if (!val && !val.trim === '') {
         callback(Error('手机号不能为空'))
         return
      }

      // 更新后的手机号正则表达式，支持190开头
      const phoneReg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;

      // 验证手机号格式
      if (!phoneReg.test(val)) {
      callback(new Error('请输入正确的手机号格式'));
      return;
      }
      // 验证通过
      callback();

    },
    validateComfullname(rul, val, callback) {
      if (this.com.comfullname && this.com.comidcode) {
        this.validateData('该单位已存在', 'comrec', 'comid', 'comfullname', this.com.comfullname, 'comidcode', this.com.comidcode, callback)
      }
    },
    validateComidcode(rul, val, callback) {
      if (this.com.comidcode) {
        this.validateData('统一信用代码已存在', 'comrec', 'comid', 'comidcode', this.com.comidcode, "", "", callback)
      }

    },
    validateComnumber(rul, val, callback) {
      if (this.com.comidcode) {
        this.validateData('单位编号已存在', 'comrec', 'comid', 'comnumber', this.com.comnumber, "", "", callback)
      }

    },
    validateData(msg, tablename, fieldid, checkfield, checkval, fieldkey1, fieldkeyval1, callback) {
      request({
        url: '/validate/validateData',
        method: "post",
        data: { tablename, fieldid, checkfield, checkval: this.com[checkfield], id: this.com.comid, fieldkey1, fieldkeyval1 }
      }).then(res => {
        res === SUCCESS ? callback(Error(msg)) : callback()
      })
    },
    vggridClick(code, row) {
      this.append = row
      this.$emit(code, row)
    },
    async getAppendType() {
      this.appendTypeList = await request({
        url: '/kfgl/syscode/getSysCodeList',
        method: "get",
        params: { syscode: 'appendtype' }
      })
    },
    async getComtype() {
      this.comtypeList = await request({
        url: '/kfgl/syscode/getSysCodeList',
        method: "get",
        params: { syscode: 'cositemcomtype', syscodevals: '1,2,3,4,5' }
      })

    },
    // async getComtypes() {
    //   console.log(this.com.comid, 888)
    //   this.comtypes = await request({
    //     url: '/ywgl/com/getComtypes',
    //     method: "get",
    //     params: {comid: this.com.comid}
    //   })
    //   if(this.comtypes){
    //     this.comtypes.forEach(key=>{
    //       if(key == 2)
    //         this.iscomtypes = true
    //     })
    //   }
    // },
    async getCom() {
      let data = await request({
        method: 'get',
        url: '/ywgl/com/getComById',
        params: { comid: this.com.comid, cosid: this.$store.getters.loginUser.cosid }
      })
      if (data.length === 1) {
        this.com = data[0]
        this.com.comtype = this.com.comtype.toString()
      } else {
        this.com = {}
        // this.$message.error('找不到该平台单位')
        return
      }
    },
    async cellClick(row) {
      this.append = row.row
    },
    async getAppendList() {
      this.list = await request({
        url: '/ywgl/append/getPageList',
        method: "get",
        params: { appendfromid: this.com.comid, appendfromtype: 1 }
      })
    },
    async addAppend() {
      let i = 1
      this.list.forEach(item => {
        if (item.appendseq >= i) {
          i = item.appendseq + 1
        }
      })
      this.appendid = 0  //判断是否新增
      this.appendItem.appendfromid = this.com.comid,
        this.appendItem.appendfromtype = '1',
        this.appendItem.appendseq = i,
        this.appendItem.returnForm = 'comForm'
      this.dialogVisible = true
    },
    async chgAppend() {
      if (!this.append.id) {
        this.$message.warning('请选择一行!')
        return
      }
      this.appendItem = _.cloneDeep(this.append)
      this.dialogVisible = true
    },
    async delAppend() {
      if (!this.append.id) {
        this.$message.warning('请选择一行!')
        return
      }
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.appendItem = _.cloneDeep(this.append)
        this.list.forEach((key, index) => {
          this.list.forEach((key, index) => {
            if (key.id === this.appendItem.id) {
              this.list.splice(index, 1)
            }
          })
        })
        this.appendItem = {}
      })
    },
    async save() {
      this.submitForm('ruleForm').then(async () => {
        this.com.userid = this.$store.getters.loginUser.userid
        this.com.appendfromtype = 1
        this.com.comstatus = 3
        this.com.list = this.list
        this.com.cosid = this.$store.getters.loginUser.cosid
        const count = await this.getUserCountByMobile()
        if (count > 0) {
          this.$message.error('手机号码已被注册!')
          return
        }
        let data = await request({
          url: '/ywgl/com/addOrEdit',
          method: "post",
          data: this.com
        })
        if (data.issuccess === 1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.user.userpassword = ''
          this.$message.error('保存失败')
        }
      }).catch(() => {
      })
    },
    async getUserCountByMobile (isUpdate = 0) {
      let { count } = await request({
          url: '/xtgl/user/getUserCountByMobile',
          method: 'get',
          params: {
            usertel: this.com.commobile,
            comid: this.com.comid
          }
      })
      return count
    },
    submit() {
      this.submitForm('ruleForm').then(async () => {
        this.com.userid = this.$store.getters.loginUser.userid
        this.com.appendfromtype = 1
        this.com.comstatus = 3
        this.com.list = this.list
        this.com.cosid = this.$store.getters.loginUser.cosid
        this.com.cositemcomstatus = 2
        let data = await request({
          url: '/ywgl/com/addOrEdit',
          method: "post",
          data: this.com
        })
        if (+data.issuccess === 1) {
          this.$message.success('提交成功')
          this.pushNotice()
          this.close()
        } else {
          this.user.userpassword = ''
          this.$message.error('保存失败')
        }
      }).catch(() => {
      })
    },
    async pushNotice() {
      let model = {}
      model.cosid = this.$store.getters.loginUser.cosid
      model.comname = this.com.comfullname
      model.tel = this.com.commobile
      model.username = this.com.comcontact
      await request({
        url: '/web/web/regPush',
        method: "post",
        data: model
      })
    },
    close() {
      if (this.type === 4) {
        this.$store.commit('close_tab', { routeName: this.$route.name, vm: this, newRouteName: '' })
      } else {
        this.$store.commit('close_tab', { routeName: this.$route.name, vm: this, newRouteName: 'comIndex' })
      }
    },
    async handleClose(done) {
      this.appendItem = {}
      this.dialogVisible = false
    },
    async setPic(path, filename, filecode) {
      this.$set(this.appendItem, 'appendfilecode', filecode)
      this.$set(this.appendItem, 'appendfilename', filename)
      this.$set(this.appendItem, 'appendurl', path.replace(this.uploadAddr, ''))
    },
    async saveAppend() {
      this.appendTypeList.forEach(key => {
        if (key.syscodeseq == this.appendItem.appendtype) {
          this.appendItem.appendtypedesc = key.label
        }
      })
      this.submitForm('ruleAppend').then(async () => {
        if (this.appendItem.id) {
          this.list.forEach((key, index) => {
            if (key.id === this.appendItem.id) {
              this.list.splice(index, 1, this.appendItem)
            }
          })
        }
        else {
          this.list.push(this.appendItem)
        }
        this.dialogVisible = false
        this.append = this.appendItem
        this.appendItem = {}
      }).catch(() => {
      })
    },
    async getcomsuserList() {
      let query = {
        comid: this.$store.getters.loginUser.usercomid
      }
      let res = await request({
        method: 'get',
        url: '/xtgl/user/getPageList',
        params: query
      })
      this.comsuserList = res.list
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-box {
  overflow: hidden;

  .vxe-button {
    padding: 10px 10px;
    font-size: 16px;
  }
}

.main {

  /*margin-bottom: 50px;*/
  .from_input .el-input,
  .el-input .el-input__inner,
  .el-select {
    width: 250px;
  }

  .content .el-textarea__inner,
  .el-textarea,
  .el-input {
    width: 620px;
  }

  .httpinput {

    .el-input,
    .mainfrom .el-input .el-input__inner,
    .mainfrom .el-select {
      width: 250px !important;
    }
  }
}
</style>
